import React, { useContext } from 'react';
import { Button } from 'antd';
import coinShadow from 'assets/images/coin-shadow.png';
import ModalEndSubmit from 'components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';

interface Props {
  visible: boolean;
  setVisible: Function;
  closeTask?: Function;
}

const ModalFinish = ({ visible, setVisible, closeTask }: Props) => {

  return (
    <ModalEndSubmit
      visible={visible}
      setVisible={setVisible}
      buttonAction={{ hidden: true }}
      modal={{
        title: 'Great job!',
        description: (
          <h4 className="h4 h4-w4">
            {`You just add a new document for the loan. You can see it in loan details section.`}
          </h4>
        )
      }}
      className=""
      icon={coinShadow}
      buttonSubmit={
        <Button
          htmlType="submit"
          className="button button-modal-ok"
          onClick={() => {
            setVisible(false);
            if(closeTask)
              closeTask();
          }}
        >
          Back to dashboard
        </Button>
      }
    />
  );
};
export default ModalFinish;
